import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../pages/Home.css'

const ServicesDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleServicesDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <li className="nav-item nav-item-li dropdown">
  <div className="nav-link-container">
    <Link to={"/services"}>
    <a style={{padding:'4px 10px'}} className="nav-link navhover" id="services_submenu">
    Services
    </a>
    </Link>
    <button
      onClick={toggleServicesDropdown}
      className="dropdown-toggle-icon"
      aria-expanded={isOpen}
    >
      <box-icon 
        name={isOpen ? 'chevron-up' : 'chevron-down'}
      ></box-icon>
    </button>
  </div>

  <ul className={`dropdown-menu ${isOpen ? 'show' : ''}`}>
    <li>
      <Link to="/web-development" className="dropdown-item">
        Web Development
      </Link>
    </li>
    <li>
      <Link to="/graphic-designing" className="dropdown-item">
        Graphic Designing
      </Link>
    </li>
    <li>
      <Link to="/search-engine-optimization" className="dropdown-item">
        Search Engine Optimization
      </Link>
    </li>
    <li>
      <Link to="/network-security" className="dropdown-item">
        Network and Security
      </Link>
    </li>
  </ul>
</li>

  );
};

export default ServicesDropdown;
